import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const navigate = useNavigate();
  
  // Form state
  const [signupData, setSignupData] = useState({
    fullName: "",
    email: "",
    password: "",
    phone: "",
    organization: ""
  });
  
  const [loginData, setLoginData] = useState({
    email: "",
    password: ""
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    // Validate required fields
    if (!signupData.fullName || !signupData.email || !signupData.password || !signupData.phone) {
      setError("Please fill in all required fields");
      setLoading(false);
      return;
    }

    // Validate full name (must have at least first name)
    if (signupData.fullName.trim().length < 2) {
      setError("Please enter a valid name");
      setLoading(false);
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(signupData.email)) {
      setError("Please enter a valid email address");
      setLoading(false);
      return;
    }

    // Validate password strength
    if (signupData.password.length < 8) {
      setError("Password must be at least 8 characters long");
      setLoading(false);
      return;
    }

    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(signupData.password)) {
      setError("Password must contain at least one uppercase letter, one lowercase letter, and one number");
      setLoading(false);
      return;
    }

    // Validate phone format (basic validation for US format)
    const phoneRegex = /^[\d\s\-()+]{10,}$/;
    if (!phoneRegex.test(signupData.phone)) {
      setError("Please enter a valid phone number (at least 10 digits)");
      setLoading(false);
      return;
    }

    try {
      // Split full name into first and last name
      const nameParts = signupData.fullName.trim().split(" ");
      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(" ") || firstName;

      // Call the API
      const response = await fetch("/api/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          FirstName: firstName,
          LastName: lastName,
          Email: signupData.email,
          Phone: signupData.phone,
          Organization: signupData.organization
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess("Account created successfully!");
        setTimeout(() => {
          navigate("/intake/start");
        }, 1500);
      } else {
        setError(data.error || "Failed to create account. Please try again.");
      }
    } catch (err) {
      console.error("Signup error:", err);
      setError("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // TODO: Implement login API call
    // For now, just navigate
    setTimeout(() => {
      navigate("/dashboard");
      setLoading(false);
    }, 500);
  };

  return (
    //className="pageAuth"
     <div style={{width:"100%"}}> 
      {error && (
        <div style={{
          padding: "1rem",
          margin: "1rem",
          backgroundColor: "#fee",
          border: "1px solid #fcc",
          borderRadius: "4px",
          color: "#c00"
        }}>
          {error}
        </div>
      )}
      
      {success && (
        <div style={{
          padding: "1rem",
          margin: "1rem",
          backgroundColor: "#efe",
          border: "1px solid #cfc",
          borderRadius: "4px",
          color: "#060"
        }}>
          {success}
        </div>
      )}
      
      <div style={{display:"flex", flexDirection:"row", justifyContent:"space-evenly"}}>

        <div style={{margin: "15px", width:"100%",display:"flex", flexDirection:"column"}}>
          <h2>Create an Account</h2>
          <form onSubmit={handleSignup} style={{ display:"flex", flexDirection:"column"}}>
            <input 
              placeholder="Full Name*" 
              value={signupData.fullName}
              onChange={(e) => setSignupData({...signupData, fullName: e.target.value})}
              disabled={loading}
            />
            <input 
              type="email"
              placeholder="Email*" 
              value={signupData.email}
              onChange={(e) => setSignupData({...signupData, email: e.target.value})}
              disabled={loading}
            />
            <input 
              type="password"
              placeholder="Password*" 
              value={signupData.password}
              onChange={(e) => setSignupData({...signupData, password: e.target.value})}
              disabled={loading}
            />
            <span style={{
              fontSize: "0.85rem",
              color: "#666",
              marginTop: "-8px",
              marginBottom: "8px",
              marginLeft: "4px"
            }}>
              Must be at least 8 characters with uppercase, lowercase, and number
            </span>
            <input 
              type="tel"
              placeholder="Phone Number*" 
              value={signupData.phone}
              onChange={(e) => setSignupData({...signupData, phone: e.target.value})}
              disabled={loading}
            />
            <input 
              placeholder="Organization Name (optional)" 
              value={signupData.organization}
              onChange={(e) => setSignupData({...signupData, organization: e.target.value})}
              disabled={loading}
            />
            <span style={{marginBottom:"5px"}}>* required</span>
          <button 
            type="submit"
            className="btn primary"
            style={{width:"50%", alignSelf:"center"}} 
            disabled={loading}>
              {loading ? "Creating Account..." : "Sign Up"}
            </button>
          </form>
        </div>
        <span style={{alignSelf:"center"}}>OR</span>
        <div style={{margin: "15px", width:"100%", display:"flex", flexDirection:"column"}}>
          <h2>Login</h2>
          <form onSubmit={handleLogin} style={{display:"flex", flexDirection:"column"}}>
            <input 
              type="email"
              placeholder="Email*" 
              value={loginData.email}
              onChange={(e) => setLoginData({...loginData, email: e.target.value})}
              disabled={loading}
            />
            <input 
              type="password"
              placeholder="Password*" 
              value={loginData.password}
              onChange={(e) => setLoginData({...loginData, password: e.target.value})}
              disabled={loading}
            />
            <span style={{marginBottom:"5px"}}>* required</span>
          <button 
            type="submit"
            className="btn primary"
            style={{width:"50%", alignSelf:"center"}} 
            disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}
